import React, {useState} from 'react'
import {
  NoContentPlaceholder,
  RRuleTag,
  useLocationContext,
  useRPC,
} from '@therms/react-modules'
import {RPCDocs, RPCs} from '@therms/rpc-gateway'
import {Button, Icon, Loading} from '@therms/atalaya'
import {FaHistory} from 'react-icons/fa'
import {LocationTaskHistoryModal} from './LocationTaskHistoryModal.tsx'
import {MdTask} from 'react-icons/md'
import Status = RPCDocs.Locations.GetLocationTasks.v1.Status

function LocationTaskScheduleTags({
  task,
}: {
  task: RPCDocs.Locations.GetLocationTasks.v1.LocationTask
}) {
  return (
    <>
      {task.schedule.map((rrule, index) => (
        <div
          className="bg-surface-subtle p-xxs rounded"
          key={`${rrule}/${index}`}
        >
          <RRuleTag rruleString={rrule} />
        </div>
      ))}
    </>
  )
}

export function LocationTaskList() {
  const [showTaskHistoryModal, setShowTaskHistoryModal] = useState('')

  const {locationId} = useLocationContext(true)
  const {data, isCalling} = useRPC<
    RPCDocs.Locations.GetLocationTasks.v1.Args,
    RPCDocs.Locations.GetLocationTasks.v1.Data
  >(RPCs.Locations.GetLocationTasks.v1, {
    locationAndGroupIds: [locationId],
    status: Status.Active,
  })

  const tasks = data?.locationTasks

  return (
    <div>
      {isCalling && !data?.locationTasks && <Loading overlay />}

      <div
        className="space-y-xs sm:grid"
        style={{gridTemplateColumns: '340px 1fr'}}
      >
        {tasks?.map((task) => (
          <div
            key={task.id}
            className="bg-surface col-span-full grid grid-cols-subgrid rounded-md"
          >
            <div className="border-border p-base flex flex-col border-b sm:border-b-0 sm:border-r">
              <div className="text-color-strong text-md mt-xxs font-semibold">
                {task.title}
              </div>

              <div className="gap-xxs flex grow flex-wrap justify-between">
                <span className="text-color-faded text-sm first-letter:capitalize">
                  {task.description}
                </span>

                <Button
                  className="ml-auto self-end"
                  onClick={() => setShowTaskHistoryModal(task.id)}
                  size="xs"
                  variant="main"
                  subtle
                >
                  <div className="px-xxs gap-xxs flex items-center">
                    <FaHistory /> History
                  </div>
                </Button>
              </div>
            </div>

            {task.schedule && (
              <div className="p-xs space-y-px text-xs">
                <LocationTaskScheduleTags task={task} />
              </div>
            )}
          </div>
        ))}

        {!tasks?.length && (
          <NoContentPlaceholder icon={<Icon Icon={MdTask} size="xl" />}>
            No tasks found
          </NoContentPlaceholder>
        )}
      </div>

      {showTaskHistoryModal && (
        <LocationTaskHistoryModal
          closeHandler={() => setShowTaskHistoryModal('')}
          locationTaskId={showTaskHistoryModal}
        />
      )}
    </div>
  )
}
